export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
    {
      title: "Cancel Return",
      cls: "cancel-return",
      icon: "ban",
      disabled:true
    }
  ],
  "actions": [
    {
      title: "View Label",
      cls: "view-label",
      icon: "file-text-o",
      disabled:false
    },
/*    {
      title: "Approve Return",
      cls: "approve-return",
      icon: "check",
      disabled:false
    },
    {
      title: "Reject Return",
      cls: "reject-return",
      icon: "times",
      disabled:false
    },
    {
      title: "Track Return",
      cls: "track-return",
      icon: "truck",
      disabled:false
    },*/
    {
      title: "Cancel Return",
      cls: "cancel-return",
      icon: "ban",
      disabled:false
    },
    {
      title: "Start Return",
      cls: "start-return",
      icon: "mail-reply",
      disabled:false
    }
  ]
};


// WEBPACK FOOTER //
// ./src/pages/rma/filter/actionOptions.js